import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import fetchTodos from '../redux/todos/thunk/fetchTodos';
import BookCard from './BookCard';

const BookList = ({keyWord, isUpdate,setIsUpdate,  setbookInputs }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTodos);
}, [dispatch]);
const[filterBooks,setFilterBooks]=useState([])

    const {bookslist}=useSelector(state=>state);
    const [featureToggle,setFeatureToggle]=useState(false);

   useEffect(()=>{
    if(featureToggle){
      setFilterBooks(bookslist.filter(book=>book.featured==true))
    }else if(keyWord){
      setFilterBooks(bookslist.filter(book=>book.name.includes(keyWord)))
    }else{
      setFilterBooks(bookslist) 

    }
   },[featureToggle,bookslist,keyWord])

   useEffect(()=>{
    if(keyWord){

      setFeatureToggle(false)
    }
   },[keyWord])

  return (
    <> <div className="order-2 xl:-order-1">
    <div className="flex items-center justify-between mb-12">
      <h4 className="mt-2 text-xl font-bold">Book List</h4>
      <div className="flex items-center space-x-4">
        <button className={ featureToggle ? "filter-btn" : "filter-btn active-filter"} id="lws-filterAll"  onClick={()=>setFeatureToggle(false)}>All</button>
        <button className={ featureToggle ? "filter-btn active-filter" : "filter-btn" }  id="lws-filterFeatured" onClick={()=>setFeatureToggle(true)}>Featured</button>
      </div>
    </div>
    <div className="lws-bookContainer">
      {/* Card 1 */}

      {
        filterBooks.map(book => 
            <BookCard setIsUpdate={setIsUpdate} setbookInputs={setbookInputs} key={book.id} book={book} />
            
            )
      }
    </div>
  </div></>
  )
}

export default BookList